<div class="clr-row nxm clr-justify-content-between margin-10-t">
  <div class="btn-group btn-sm btn-icon">
    <app-all-selected-btn [(selected)]="selectedLeft" [all]="filterStoreLeft.filteredRows()" />
    <button
      class="btn"
      (click)="filterStoreLeft.deleteAllFilters()"
      [disabled]="filterStoreLeft.filteredRows().length == tableLeft().rows.length">
      <clr-tooltip>
        <cds-icon clrTooltipTrigger shape="filter-off" />
        <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
          {{ 'Alle Filter zurücksetzen' | mrTranslate }}
        </clr-tooltip-content>
      </clr-tooltip>
    </button>
  </div>
  <clr-select-container class="nm">
    <select clrSelect [(ngModel)]="selectedGroup" [ngModelOptions]="{ standalone: true }">
      <option [ngValue]="undefined">{{ 'Gruppe auswählen' | mrTranslate }}</option>
      @for (group of groups(); track group.id) {
        <option [ngValue]="+group.id">{{ group.Bezeichnung }}</option>
      }
    </select>
  </clr-select-container>
  <div class="btn-group btn-sm btn-icon">
    <button
      class="btn"
      (click)="filterStoreRight.deleteAllFilters()"
      [disabled]="filterStoreRight.filteredRows().length == tableRight().rows.length">
      <clr-tooltip>
        <cds-icon clrTooltipTrigger shape="filter-off" />
        <clr-tooltip-content [clrPosition]="'bottom-right'" [clrSize]="'md'">
          {{ 'Alle Filter zurücksetzen' | mrTranslate }} {{ 'rechts' | mrTranslate }}
        </clr-tooltip-content>
      </clr-tooltip>
    </button>
    <app-all-selected-btn [(selected)]="selectedRight" [all]="filterStoreRight.filteredRows()" />
  </div>
</div>
@if (selectedGroup()) {
  <div class="d-f row h-60">
    @if (tableLeft().columns.length) {
      <clr-datagrid
        class="datagrid-compact h-100 fill-space"
        [clrDgSelectionType]="'multi'"
        [clrDgSelected]="selectedLeft()"
        [clrDgRowSelection]="true"
        (clrDgSelectedChange)="selectedLeft.set($event)"
        [clrDgItemsIdentityFn]="row => row?.[trackByKey()]">
        @for (column of tableLeft().columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <clr-dg-filter>
              <app-column-filter
                #left
                [column]="column"
                [objektTypIconValue]="filterStoreLeft.iconMap()"
                [uniqueColumnValues]="filterStoreLeft.uniqueValues()[column.id]"
                (changes)="filterStoreLeft.onChange($event)" />
            </clr-dg-filter>
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="filterStoreLeft.filteredRows()"
          [clrVirtualRowsTrackBy]="(_, row) => row?.[trackByKey()]">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of tableLeft().columns; track cell.id) {
              @if (cell.id == 'typ') {
                <clr-dg-cell class="fill-black">
                  <cds-icon
                    size="26"
                    class="grid-icon"
                    [title]="row.typ"
                    [shape]="row.typ_icon ? 'objekttyp' + row.typ_icon : 'unknown-status'" />
                </clr-dg-cell>
              } @else {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            }
          </clr-dg-row>
        </ng-template>

        <clr-dg-footer>{{ filterStoreLeft.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
      <div class="move-buttons padding-10-lr">
        <button
          class="btn btn-link btn-state btn-state-custom-size add"
          [title]="'Objekt zur Gruppe hinzufügen' | mrTranslate"
          [class.disabled-menu-item]="!selectedLeft().length"
          [disabled]="!selectedLeft().length"
          (click)="save('add')"
          [clrLoading]="moveState()">
          <cds-icon shape="circle-arrow" direction="right" />
        </button>
        <button
          class="btn btn-link btn-state btn-state-custom-size delete"
          [title]="'Objekt aus der Gruppe entfernen' | mrTranslate"
          [class.disabled-menu-item]="!selectedRight().length"
          [disabled]="!selectedRight().length"
          (click)="save('remove')"
          [clrLoading]="moveState()">
          <cds-icon shape="circle-arrow" direction="left" solid="true" />
        </button>
      </div>
    } @else {
      <clr-spinner class="centred"/>
    }
    @if (tableRight().columns.length) {
      <clr-datagrid
        class="datagrid-compact h-100 fill-space"
        [clrDgSelectionType]="'multi'"
        [clrDgSelected]="selectedRight()"
        [clrDgRowSelection]="true"
        (clrDgSelectedChange)="selectedRight.set($event)"
        [clrDgItemsIdentityFn]="row => row?.[trackByKey()]">
        @for (column of tableRight().columns; track column.id) {
          <clr-dg-column [clrDgField]="column.id">
            <clr-dg-filter>
              <app-column-filter
                #left
                [column]="column"
                [objektTypIconValue]="filterStoreRight.iconMap()"
                [uniqueColumnValues]="filterStoreRight.uniqueValues()[column.id]"
                (changes)="filterStoreRight.onChange($event)" />
            </clr-dg-filter>
            <ng-container *clrDgHideableColumn="{ hidden: column.id | hideIDColumns }">
              {{ column.id | titlecase | mrTranslate }}
            </ng-container>
          </clr-dg-column>
        }
        <ng-template
          clrVirtualScroll
          let-row
          [clrVirtualRowsOf]="filterStoreRight.filteredRows()"
          [clrVirtualRowsTrackBy]="(_, row) => row?.[trackByKey()]">
          <clr-dg-row [clrDgItem]="row">
            @for (cell of tableRight().columns; track cell.id) {
              @if (cell.id == 'typ') {
                <clr-dg-cell class="fill-black">
                  <cds-icon
                    size="26"
                    class="grid-icon"
                    [title]="row.typ"
                    [shape]="row.typ_icon ? 'objekttyp' + row.typ_icon : 'unknown-status'" />
                </clr-dg-cell>
              } @else {
                <clr-dg-cell class="name-cell">{{ row[cell.id] | tablePrettyPrint }}</clr-dg-cell>
              }
            }
          </clr-dg-row>
        </ng-template>

        <clr-dg-footer>{{ filterStoreRight.filteredRows().length }} {{ 'Zeilen' | mrTranslate }}</clr-dg-footer>
      </clr-datagrid>
    }
  </div>
}
